<div class="position-relative d-flex gallery-container rounded-lg">

  <ng-container *ngIf="mediaGallery.length">
    <cci-image *ngIf="mediaGallery[imageIndex]?.type === 'image'"
      [image]="mediaGallery[imageIndex]?.image"
      [size]="size"
      (imageLoaded)="onImageLoaded()"></cci-image>

    <cci-image *ngIf="nextImage"
      class="d-none"
      [image]="nextImage"
      loading="eager"
      [size]="size"></cci-image>

    <iframe width="100%"
      *ngIf=" mediaGallery[imageIndex]?.type === 'video'"
      height="100%"
      [src]="mediaGallery[imageIndex]?.videoUrl"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope;"
      allowfullscreen
      loading="lazy"></iframe>

    <button mat-button
      class="zoom-btn rounded-pill px-2"
      *ngIf="showZoom && mediaGallery[imageIndex].type === 'image'"
      (click)="onZoom()">
      <mat-icon>zoom_in</mat-icon>
      {{'COMMON.LABEL.ZOOM' | translate}}
    </button>

    <button mat-icon-button
      class="left arrow"
      *ngIf="showGallery && mediaGallery?.length > 1"
      (click)="showPreviousImage($event)">
      <mat-icon>chevron_left</mat-icon>
    </button>

    <button mat-icon-button
      class="right arrow"
      *ngIf="showGallery && mediaGallery?.length > 1"
      (click)="showNextImage($event)">
      <mat-icon>chevron_right</mat-icon>
    </button>

    <div class="counter rounded-pill px-1">
      {{imageIndex+1}}/{{mediaGallery.length}}
    </div>
  </ng-container>

  <img *ngIf="!mediaGallery?.length"
    src="/assets/img/car-placeholder.png">

</div>